import React, { useState, useEffect } from 'react';

const wait = (ms) => {
    //console.log('Hello');
    const date = Date.now();
    let currentDate = null;
    do {
        currentDate = Date.now();
    } while (currentDate - date < ms);
    //console.log('World!');
};

export const GetTestInfo = (matricula) => {

    const matriculasJson = [
        '00000347953',
        '00000360173',
        '00000328933',
        '00000389094',
        '00000431915'
    ]

    if (matriculasJson.includes(matricula)) {
        return fetch(`http://localhost/tests/${matricula}.json`)
            .then(data => {
                return data.json()
            })
            .then(data => {
                wait(100)
                return { data: data }
            })
            .catch(err => { console.log(err) });
    }

    let testInfo = '';

    if (matricula === '00000407351') {
        testInfo = `
    [{
        "matricula": "00000407351",
        "grado": "EDCN",
        "numerodegrado": 0,
        "resultadoactivacion": false,
        "institucion": "UTNSL",
        "campus": "00003",
        "programaacademico": "INL4E",
        "planacademico": "INLS0E19",
        "planacademicosec": "NA",
        "appaterno": "CAMACHO",
        "apmaterno": "ELIZALDE",
        "nombre": "SERGIO ROMMEL",
        "descrgrado": "Educaci?n Continua",
        "descrcampus": "Campus Industrias",
        "descrprograma": "Ingl?s 2019",
        "tipoplanacademico": "MFL",
        "estadoprograma": "AC",
        "descrestadoprograma": "Activo en Programa",
        "accionprograma": "MATR",
        "descraccionprograma": "Matr?cula",
        "turno": "VESPERTINO",
        "ccladmision": "2431",
        "calculodemapa": "Y",
        "cclcategoria": "",
        "descrcclcategoria": "",
        "cclactual": "",
        "descrcicloactual": "",
        "nivacadactual": "",
        "descrnivacadactual": "",
        "cclinscripcion": "",
        "descrcclinscripcion": "25-01",
        "nivacadinscripcion": "",
        "nivacadinscripcionnbr": "",
        "descrnivacadinscripcion": "",
        "fechainiciocclinscripcion": "",
        "fechafincclinscripcion": "",
        "tipoinscripcion": "RI",
        "costoinscripcion": 0,
        "costopaquete": 0,
        "minimopaquete": 0,
        "maximopaquete": 0,
        "costoclaseadicional": 0,
        "notaclaseorigen": [
        ],
        "requisitos": [
            {
                "etiqueta": "Matriculaci?n",
                "resultado": "NO",
                "cumple": "No Cumple",
                "mensaje": "Es necesario que todos tus datos estar correctos por favor acude a Servicio Escolares de tu Campus",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQMATR",
                "requerido": "SI",
                "mensajerequerido": "Todos los datos relacionado con tu matriculaci?n deben de estar correctos",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Turno",
                        "valor": "VESPERTINO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Acci?n de Programa",
                        "valor": "MATR|Matr?cula",
                        "mostrar": "NO",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Elegible a Inscripci?n",
                        "valor": "NO",
                        "mostrar": "NO",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Plan de Pago",
                        "valor": "NO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Adeudo Ciclos Anteriores",
                        "valor": "SI",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Vencimiento Inscripci?n",
                        "valor": "",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Vencimiento Colegiatura",
                        "valor": "",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Cobro Inscripci?n",
                        "valor": "NO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Cobro Colegiatura",
                        "valor": "NO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Activaci?n al Ciclo de Inscripci?n",
                "resultado": "NO",
                "cumple": "No Cumple",
                "mensaje": "Es necesario estar inscrito al ciclo de inscripci?n",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQACTCCL",
                "requerido": "SI",
                "mensajerequerido": "La activaci?n al ciclo es un requisito para el alta correcta de tus materias",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Ciclo de Inscripci?n",
                        "valor": "",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Adeudos en Ciclos Anteriores",
                "resultado": "SI",
                "cumple": "No Cumple",
                "mensaje": "Es necesario que liquides todos los adeudos de pago de ciclos anteriores",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQADEUDO",
                "requerido": "SI",
                "mensajerequerido": "Debes de liquidar todos tus adeudos de ciclos anteriores",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Monto del Adeudo",
                        "valor": 3927,
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Pago de Inscripci?n",
                "resultado": null,
                "cumple": "",
                "mensaje": "",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQPINS",
                "requerido": "NO",
                "mensajerequerido": "Necesitas realizar el pago de inscripci?n para dar el alta de tus materias en https://pagos.aliat.edu.mx",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Adeudo de Inscripci?n",
                        "valor": 0,
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    }
                ],
                "valor": ""
            },
            {
                "etiqueta": "Adeudo de documentos",
                "resultado": "NO",
                "cumple": "Cumple",
                "mensaje": "Correcto",
                "actualizacionportal": "SI",
                "proceso": "UpdtLstSimp",
                "mensajeportal": "Recuerda que la lista de documentos se puede actualizar en el portal de auto inscripci?n o directamente en la direcci?n administrativa de tu campus",
                "idrequisito": "REQLSTDOC",
                "requerido": "NO",
                "mensajerequerido": "Necesitas tener actualizados tus documentos",
                "mostrar": "SI",
                "lista": [
                ],
                "valor": null
            },
            {
                "etiqueta": "Evaluaci?n Docente",
                "resultado": "SC",
                "cumple": "Cumple",
                "mensaje": "No cuentas con evaluaciones por contestar",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQEVDOC",
                "requerido": "NO",
                "mensajerequerido": "Es necesario que eval?es a tus docentes de las materias que acabas de terminar",
                "mostrar": "SI",
                "lista": [
                ],
                "valor": null
            }
        ],
        "cursossugeridos": 0,
        "ofertaacademica": [
        ],
        "cursosinscritos": 0,
        "ofertainscrita": [
        ],
        "estado": {
            "valor": 2,
            "serie": 21001,
            "numero": 152,
            "mensajeportal": "Apreciable <appaterno> <apmaterno> <nombre> est?s iniciando tu proceso de Auto inscripci?n, para seguir adelante vamos a realizar tu activaci?n al ciclo <descripcioncclinscripcion>, este proceso habilita tu cuenta de inscripci?n con un precio de <costocicloinscripcion> para que puedas  realizar tu pago"
        }
    },
    {
        "matricula": "00000407351",
        "grado": "UGRD",
        "numerodegrado": 0,
        "resultadoactivacion": false,
        "institucion": "UTNSL",
        "campus": "00003",
        "programaacademico": "LAE42",
        "planacademico": "LADE0E16",
        "planacademicosec": "NA",
        "appaterno": "CAMACHO",
        "apmaterno": "ELIZALDE",
        "nombre": "SERGIO ROMMEL",
        "descrgrado": "Licenciatura",
        "descrcampus": "Campus Industrias",
        "descrprograma": "Administraci?n de Empresas",
        "tipoplanacademico": "MFL",
        "estadoprograma": "AC",
        "descrestadoprograma": "Activo en Programa",
        "accionprograma": "MATR",
        "descraccionprograma": "Matr?cula",
        "turno": "MATUTINO",
        "ccladmision": "2333",
        "calculodemapa": "Y",
        "cclcategoria": "",
        "descrcclcategoria": "",
        "cclactual": "",
        "descrcicloactual": "",
        "nivacadactual": "",
        "descrnivacadactual": "",
        "cclinscripcion": "",
        "descrcclinscripcion": "25-01",
        "nivacadinscripcion": "",
        "nivacadinscripcionnbr": "",
        "descrnivacadinscripcion": "",
        "fechainiciocclinscripcion": "",
        "fechafincclinscripcion": "",
        "tipoinscripcion": "RI",
        "costoinscripcion": 0,
        "costopaquete": 0,
        "minimopaquete": 0,
        "maximopaquete": 0,
        "costoclaseadicional": 0,
        "notaclaseorigen": [
        ],
        "requisitos": [
            {
                "etiqueta": "Matriculaci?n",
                "resultado": "NO",
                "cumple": "No Cumple",
                "mensaje": "Es necesario que todos tus datos estar correctos por favor acude a Servicio Escolares de tu Campus",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQMATR",
                "requerido": "SI",
                "mensajerequerido": "Todos los datos relacionado con tu matriculaci?n deben de estar correctos",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Turno",
                        "valor": "MATUTINO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Acci?n de Programa",
                        "valor": "MATR|Matr?cula",
                        "mostrar": "NO",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Elegible a Inscripci?n",
                        "valor": "NO",
                        "mostrar": "NO",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Plan de Pago",
                        "valor": "NO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Adeudo Ciclos Anteriores",
                        "valor": "SI",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Vencimiento Inscripci?n",
                        "valor": "",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Vencimiento Colegiatura",
                        "valor": "",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Cobro Inscripci?n",
                        "valor": "NO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Cobro Colegiatura",
                        "valor": "NO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Activaci?n al Ciclo de Inscripci?n",
                "resultado": "NO",
                "cumple": "No Cumple",
                "mensaje": "Es necesario estar inscrito al ciclo de inscripci?n",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQACTCCL",
                "requerido": "SI",
                "mensajerequerido": "La activaci?n al ciclo es un requisito para el alta correcta de tus materias",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Ciclo de Inscripci?n",
                        "valor": "",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Adeudos en Ciclos Anteriores",
                "resultado": "SI",
                "cumple": "No Cumple",
                "mensaje": "Es necesario que liquides todos los adeudos de pago de ciclos anteriores",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQADEUDO",
                "requerido": "SI",
                "mensajerequerido": "Debes de liquidar todos tus adeudos de ciclos anteriores",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Monto del Adeudo",
                        "valor": 3927,
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Pago de Inscripci?n",
                "resultado": null,
                "cumple": "",
                "mensaje": "",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQPINS",
                "requerido": "NO",
                "mensajerequerido": "Necesitas realizar el pago de inscripci?n para dar el alta de tus materias en https://pagos.aliat.edu.mx",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Adeudo de Inscripci?n",
                        "valor": 0,
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": null,
                        "valcumple": null
                    }
                ],
                "valor": ""
            },
            {
                "etiqueta": "Adeudo de documentos",
                "resultado": "SI",
                "cumple": "No Cumple",
                "mensaje": "Es necesario actualizar tu lista de documentos",
                "actualizacionportal": "SI",
                "proceso": "UpdtLstSimp",
                "mensajeportal": "Recuerda que la lista de documentos se puede actualizar en el portal de auto inscripci?n o directamente en la direcci?n administrativa de tu campus",
                "idrequisito": "REQLSTDOC",
                "requerido": "NO",
                "mensajerequerido": "Necesitas tener actualizados tus documentos",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "CURP",
                        "valor": "Pendiente",
                        "mostrar": "SI",
                        "secuencia": 20,
                        "elementolistacontrol": "A002",
                        "cumple": "No Cumple",
                        "valcumple": [
                            "E"
                        ]
                    },
                    {
                        "etiqueta": "Antecedente Acad?mico",
                        "valor": "Entregado",
                        "mostrar": "SI",
                        "secuencia": 30,
                        "elementolistacontrol": "A003",
                        "cumple": "Cumple",
                        "valcumple": [
                            "E"
                        ]
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Evaluaci?n Docente",
                "resultado": "SC",
                "cumple": "Cumple",
                "mensaje": "No cuentas con evaluaciones por contestar",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQEVDOC",
                "requerido": "NO",
                "mensajerequerido": "Es necesario que eval?es a tus docentes de las materias que acabas de terminar",
                "mostrar": "SI",
                "lista": [
                ],
                "valor": null
            }
        ],
        "cursossugeridos": 0,
        "ofertaacademica": [
        ],
        "cursosinscritos": 0,
        "ofertainscrita": [
        ],
        "estado": {
            "valor": 2,
            "serie": 21001,
            "numero": 152,
            "mensajeportal": "Apreciable <appaterno> <apmaterno> <nombre> est?s iniciando tu proceso de Auto inscripci?n, para seguir adelante vamos a realizar tu activaci?n al ciclo <descripcioncclinscripcion>, este proceso habilita tu cuenta de inscripci?n con un precio de <costocicloinscripcion> para que puedas  realizar tu pago"
        }
    }]`;

    } 

   
    if (matricula === '00000415875') 
    {
        testInfo = `
[
    {
        "matricula": "00000415875",
        "grado": "UGRD",
        "numerodegrado": 1,
        "resultadoactivacion": {
            "valor": false,
            "serie": 0,
            "numero": 0,
            "mensajeportal": ""
        },
        "institucion": "CNDIA",
        "campus": "00002",
        "programaacademico": "LAE42",
        "planacademico": "LADE0E16",
        "planacademicosec": "NA",
        "appaterno": "ALONSO",
        "apmaterno": "DELFINO",
        "nombre": "NORMA VALERIA",
        "descrgrado": "Licenciatura",
        "descrcampus": "Campus Fórum Internacional",
        "descrprograma": "Administración de Empresas",
        "tipoplanacademico": "MFL",
        "estadoprograma": "AC",
        "descrestadoprograma": "Activo en Programa",
        "accionprograma": "RADM",
        "descraccionprograma": "Readmisión",
        "turno": "MATUTINO",
        "ccladmision": "2433",
        "calculodemapa": "Y",
        "cclcategoria": "C",
        "descrcclcategoria": "Cuatrimestral",
        "cclactual": "2433",
        "descrcicloactual": "24-03 C",
        "nivacadactual": "N1",
        "descrnivacadactual": "Cuatrimestre 1",
        "cclinscripcion": "2531",
        "descrcclinscripcion": "25-01 C",
        "nivacadinscripcion": "N2",
        "nivacadinscripcionnbr": "2",
        "descrnivacadinscripcion": "Cuatrimestre 1",
        "fechainiciocclinscripcion": "2025-01-13",
        "fechafincclinscripcion": "2025-05-18",
        "tipoinscripcion": "RI",
        "costoinscripcion": 5586,
        "costopaquete": 11838,
        "minimopaquete": 5,
        "maximopaquete": 5,
        "costoclaseadicional": 2415,
        "notaclaseorigen": [
            "1AME"
        ],
        "requisitos": [
            {
                "etiqueta": "Matriculación",
                "resultado": "NO",
                "cumple": "No Cumple",
                "mensaje": "Es necesario que todos tus datos estar correctos por favor acude a Servicio Escolares de tu Campus",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQMATR",
                "requerido": "SI",
                "mensajerequerido": "Todos los datos relacionado con tu matriculación deben de estar correctos",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Turno",
                        "valor": "MATUTINO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Acción de Programa",
                        "valor": "Readmisión",
                        "mostrar": "NO",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Elegible a Inscripción",
                        "valor": "SI",
                        "mostrar": "NO",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Plan de Pago",
                        "valor": "NO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Adeudo Ciclos Anteriores",
                        "valor": "NO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Vencimiento Inscripción",
                        "valor": "SI",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Vencimiento Colegiatura",
                        "valor": "SI",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Cobro Inscripción",
                        "valor": "NO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Cobro Colegiatura",
                        "valor": "SI",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Activación al Ciclo de Inscripción",
                "resultado": "SI",
                "cumple": "Cumple",
                "mensaje": "Correcto",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQACTCCL",
                "requerido": "SI",
                "mensajerequerido": "La activación al ciclo es un requisito para el alta correcta de tus materias",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Ciclo de Inscripción",
                        "valor": "2531",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Adeudos en Ciclos Anteriores",
                "resultado": "NO",
                "cumple": "Cumple",
                "mensaje": "Correcto",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQADEUDO",
                "requerido": "SI",
                "mensajerequerido": "Debes de liquidar todos tus adeudos de ciclos anteriores",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Monto del Adeudo",
                        "valor": 0,
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Pago de Inscripción",
                "resultado": null,
                "cumple": "No Cumple",
                "mensaje": "Necesitas realizar el pago de inscripción para dar el alta de tus materias en <a href='https://pagos.aliat.edu.mx'>Portal de Pagos</a>",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQPINS",
                "requerido": "SI",
                "mensajerequerido1": "Necesitas realizar el pago de inscripción para dar el alta de tus materias en <a href='https://pagos.aliat.edu.mx'>Portal de Pagos</a>",
                "mensajerequerido": "Es necesario que cumplas con el pago de inscripción",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Adeudo de Inscripción",
                        "valor": 5450.75,
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    }
                ],
                "valor": "NO"
            },
            {
                "etiqueta": "Adeudo de documentos",
                "resultado": "NO",
                "cumple": "Cumple",
                "mensaje": "Correcto",
                "actualizacionportal": "SI",
                "proceso": "UpdtLstSimp",
                "mensajeportal": "Recuerda que la lista de documentos se puede actualizar en el portal de auto reinscripción o directamente en la dirección administrativa de tu campus",
                "idrequisito": "REQLSTDOC",
                "requerido": "SI",
                "mensajerequerido": "Necesitas tener actualizados tus documentos",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "CURP",
                        "valor": "Entregado",
                        "mostrar": "SI",
                        "secuencia": 20,
                        "elementolistacontrol": "A002",
                        "cumple": "Cumple",
                        "valcumple": [
                            "E"
                        ]
                    },
                    {
                        "etiqueta": "Antecedente Académico",
                        "valor": "Prestamo",
                        "mostrar": "SI",
                        "secuencia": 30,
                        "elementolistacontrol": "A003",
                        "cumple": "No Cumple",
                        "valcumple": [
                            "E"
                        ]
                    }
                ],
                "valor": null
            },
            {
                "etiqueta": "Evaluación Docente",
                "resultado": "NO",
                "cumple": "No Cumple",
                "mensaje": "Es necesario que termines la evaluación docente",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQEVDOC",
                "requerido": "NO",
                "mensajerequerido": "Es necesario que evalúes a tus docentes de las materias que acabas de terminar",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Aprender a Aprender docente Claudia Eugenia Buenrostro Díaz",
                        "valor": "Pendiente",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Corrientes d la Administración docente Mariana Alejandrina Solano Silva",
                        "valor": "Pendiente",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Desarrollo Organizacional docente José Navarro Padilla",
                        "valor": "Pendiente",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fundamentos Contables docente Humberto Jimenez Olea",
                        "valor": "Pendiente",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Proceso Administrativo docente Rodrigo Abraham Viramontes Martínez",
                        "valor": "Pendiente",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    }
                ],
                "valor": null
            }
        ],
        "cursossugeridos": 0,
        "ofertaacademica": [],
        "cursosinscritos": 0,
        "ofertainscrita": [],
        "estado": {
            "valor": 4,
            "valor1": 2,
            "serie": 21001,
            "numero": 154,
            "mensajeportal": "Apreciable <appaterno> <apmaterno> <nombre> los requisitos para auto inscribirte al ciclo <descrcclinscripcion>, son los siguientes"
        }
    }
]
        `;

    }
    
    if (matricula === '00000347953') {
        //debugger;
        testInfo = `
[
    {
        "matricula": "00000347953",
        "grado": "UGRD",
        "numerodegrado": 0,
        "resultadoactivacion": {
            "valor": false,
            "serie": 0,
            "numero": 0,
            "mensajeportal": ""
        },
        "institucion": "UTNSL",
        "campus": "00002",
        "programaacademico": "LTS42",
        "planacademico": "LTSO0M16",
        "planacademicosec": "NA",
        "appaterno": "DIAZ",
        "apmaterno": "ARELLANOS",
        "nombre": "HILDA ELIDET",
        "descrgrado": "Licenciatura",
        "descrcampus": "Campus Huasteca",
        "descrprograma": "Trabajo Social",
        "tipoplanacademico": "MFL",
        "estadoprograma": "AC",
        "descrestadoprograma": "Activo en Programa",
        "accionprograma": "MATR",
        "descraccionprograma": "Matrícula",
        "turno": "SABATINO",
        "ccladmision": "2243",
        "calculodemapa": "Y",
        "cclcategoria": "C",
        "descrcclcategoria": "Cuatrimestral",
        "cclactual": "2443",
        "descrcicloactual": "24-03 C MX",
        "nivacadactual": "N7",
        "descrnivacadactual": "Cuatrimestre 7",
        "cclinscripcion": "2541",
        "descrcclinscripcion": "25-01 C MX",
        "nivacadinscripcion": "N8",
        "nivacadinscripcionnbr": "8",
        "descrnivacadinscripcion": "Cuatrimestre 8",
        "fechainiciocclinscripcion": "2025-01-13",
        "fechafincclinscripcion": "2025-05-18",
        "tipoinscripcion": "RI",
        "costoinscripcion": 3572,
        "costopaquete": 7050,
        "minimopaquete": 5,
        "maximopaquete": 5,
        "costoclaseadicional": 1438,
        "notaclaseorigen": [
            "7ASM"
        ],
        "requisitos": [
            {
                "etiqueta": "Información Académica",
                "resultado": "NO",
                "cumple": "Cumple",
                "mensaje": "Es necesario que todos tus datos estar correctos por favor acude a Servicio Escolares de tu Campus",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQMATR",
                "requerido": "SI",
                "mensajerequerido": "Es necesario que asistas al área de servicios escolares de tu campus para actualizar tu información",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Turno",
                        "valor": "SABATINO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Acción de Programa",
                        "valor": "Matrícula",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Elegible a Inscripción",
                        "valor": "SI",
                        "mostrar": "NO",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Plan de Pago",
                        "valor": "SI",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Adeudo Ciclos Anteriores",
                        "valor": "NO",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Vencimiento Inscripción",
                        "valor": "",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Vencimiento Colegiatura",
                        "valor": "",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Cobro Inscripción",
                        "valor": "SI",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Fechas de Cobro Colegiatura",
                        "valor": "SI",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    }
                ]
            },
            {
                "etiqueta": "Activación al Ciclo de Inscripción",
                "resultado": "SI",
                "cumple": "Cumple",
                "mensaje": "Correcto",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQACTCCL",
                "requerido": "SI",
                "mensajerequerido": "La activación al ciclo es un requisito para el alta correcta de tus materias",
                "mostrar": "NO",
                "lista": [
                    {
                        "etiqueta": "Ciclo de Inscripción",
                        "valor": "2541",
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    }
                ]
            },
            {
                "etiqueta": "Adeudos en Ciclos Anteriores",
                "resultado": "NO",
                "cumple": "Cumple",
                "mensaje": "Correcto",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQADEUDO",
                "requerido": "SI",
                "mensajerequerido": "Debes de liquidar todos tus adeudos de ciclos anteriores",
                "mostrar": "NO",
                "lista": [
                    {
                        "etiqueta": "Monto del Adeudo",
                        "valor": 0,
                        "mostrar": "NO",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "Cumple",
                        "valcumple": null
                    }
                ]
            },
            {
                "etiqueta": "Pago de Inscripción",
                "resultado": "NO",
                "cumple": "No Cumple",
                "mensaje": "Es necesario pagar la inscripción para realizar proceso",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQPINS",
                "requerido": "SI",
                "mensajerequerido": "Es necesario que cumplas con tu pago de inscripción en el ciclo",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "Adeudo de Inscripción",
                        "valor": 3502.03,
                        "mostrar": "SI",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    }
                ]
            },
            {
                "etiqueta": "Documentos completos",
                "resultado": "SI",
                "cumple": "No Cumple",
                "mensaje": "Es necesario actualizar tu lista de documentos",
                "actualizacionportal": "SI",
                "proceso": "UpdtLstSimp",
                "mensajeportal": "Recuerda que la lista de documentos se puede actualizar en el portal de auto reinscripción o directamente en la dirección administrativa de tu campus",
                "idrequisito": "REQLSTDOC",
                "requerido": "NO",
                "mensajerequerido": "Puedes seguir adelante con tu inscripción pero es deseable que completes tus documentos",
                "mostrar": "SI",
                "lista": [
                    {
                        "etiqueta": "CURP",
                        "valor": "Pendiente",
                        "mostrar": "SI",
                        "secuencia": 20,
                        "elementolistacontrol": "A002",
                        "cumple": "No Cumple",
                        "valcumple": [
                            "E"
                        ]
                    },
                    {
                        "etiqueta": "Antecedente Académico",
                        "valor": "Entregado",
                        "mostrar": "SI",
                        "secuencia": 30,
                        "elementolistacontrol": "A003",
                        "cumple": "Cumple",
                        "valcumple": [
                            "E"
                        ]
                    }
                ]
            },
            {
                "etiqueta": "Evaluación Docente",
                "resultado": "NO",
                "cumple": "NO Cumple",
                "mensaje": "Es necesario que termines la evaluación docente",
                "actualizacionportal": "NO",
                "proceso": "",
                "mensajeportal": "",
                "idrequisito": "REQEVDOC",
                "requerido": "NO",
                "mensajerequerido": "Es necesario que evalúes a tus docentes de las materias que acabas de terminar",
                "mostrar": "NO",
                "lista": [
                    {
                        "etiqueta": "Técni Para L IntervInstiYComun docente NICOLAS ALEJANDRO HERNANDEZ DELGADILLO",
                        "valor": "Pendiente",
                        "mostrar": "NO",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    },
                    {
                        "etiqueta": "Gestión De Información docente Maria Mihaela Nicolae",
                        "valor": "Pendiente",
                        "mostrar": "NO",
                        "secuencia": null,
                        "elementolistacontrol": null,
                        "cumple": "No Cumple",
                        "valcumple": null
                    }
                ]
            }
        ],
        "cursossugeridos": 0,
        "ofertaacademica": [],
        "cursosinscritos": 0,
        "ofertainscrita": [],
        "estado": {
            "valor": 4,
            "serie": 21001,
            "numero": 154,
            "mensajeportal": "Apreciable <appaterno> <apmaterno> <nombre> los requisitos para auto inscribirte al ciclo <descrcclinscripcion>, son los siguientes"
        }
    }
]
        `};



    if (!testInfo)
    { 
        testInfo = `
    [{
        "matricula": null,
        "grado": "EDCN",
        "numerodegrado": 0,
        "resultadoactivacion": false,
        "institucion": "UTNSL",
        "campus": "00003",
        "programaacademico": "INL4E",
        "planacademico": "INLS0E19",
        "planacademicosec": "NA",
        "appaterno": "CAMACHO",
        "apmaterno": "ELIZALDE",
        "nombre": "SERGIO ROMMEL",
        "descrgrado": "Educaci?n Continua",
        "descrcampus": "Campus Industrias",
        "descrprograma": "Ingl?s 2019",
        "tipoplanacademico": "MFL",
        "estadoprograma": "AC",
        "descrestadoprograma": "Activo en Programa",
        "accionprograma": "MATR",
        "descraccionprograma": "Matr?cula",
        "turno": "VESPERTINO",
        "ccladmision": "2431",
        "calculodemapa": "Y",
        "cclcategoria": "",
        "descrcclcategoria": "",
        "cclactual": "",
        "descrcicloactual": "",
        "nivacadactual": "",
        "descrnivacadactual": "",
        "cclinscripcion": "",
        "descrcclinscripcion": "25-01",
        "nivacadinscripcion": "",
        "nivacadinscripcionnbr": "",
        "descrnivacadinscripcion": "",
        "fechainiciocclinscripcion": "",
        "fechafincclinscripcion": "",
        "tipoinscripcion": "RI",
        "costoinscripcion": 0,
        "costopaquete": 0,
        "minimopaquete": 0,
        "maximopaquete": 0,
        "costoclaseadicional": 0,
        "notaclaseorigen": [
        ],
        "requisitos": [
        ],
        "cursossugeridos": 0,
        "ofertaacademica": [
        ],
        "cursosinscritos": 0,
        "ofertainscrita": [
        ],
        "estado": {
            "valor" : 1,
            "serie" : 21001,
            "numero" : 150,
            "mensajeportal" : "No eres candidato para el proceso de inscripci?n, si crees que esto es un error ac?rcate a servicios escolares de tu campus para realizar tu reinscripci?n de manera tradicional. \\r\\r ?Gracias!"
        }
    }]`;
    }

    return JSON.parse(testInfo);
}
